import { useBreakpointValue as chakraUseBreakpointValue } from '@springcare/sh-component-library';
var useBreakpointValue = chakraUseBreakpointValue;
export { useBreakpointValue };
